import React from 'react';
import {graphql} from 'gatsby';
import styled from 'styled-components';
import Img from 'gatsby-image';

import {Col, Grid, Row} from 'react-styled-flexboxgrid';

import {LinkButton} from '../atoms/Button';
import {H2, H3, H6Small, P} from '../atoms/TextComponents';
import Section from '../atoms/Section/Section';
import {FluidImageWrapper} from '../atoms/Images/Images.jsx';
import TestimonialSlider from '../components/TestimonialSlider';
import FlexWrapper from '../components/shared/FlexWrapper';
import HeroComponent from '../components/shared/HeroComponent';
import LogoSlider from '../components/LogoSlider';
import CTABlock from '../components/shared/CtaBlock';
import {BreakpointContext} from '../context/BreakpointContext';
import {Container} from '../atoms/Container';
import {GradientSection} from '../components/shared/GradientSection';
import {makeBreadCrumbJson, SEO} from '../components/shared/seo';

const TestimonialSection = styled(Section)`
  padding: 64px 0;
  background-color: ${({theme}) => theme.colors.gray800};
`;

const FeaturesSection = styled(GradientSection)`
  .call-to-action-link-wrapper {
    margin-top: 24px;
  }
`;

export default class RootIndex extends React.Component {
  constructor(props) {
    super(props);
    this.scrollAnchorRef = React.createRef();
    this.state = {pageHasLoaded: false};
  }

  componentDidMount() {
    this.state.pageHasLoaded = true;
  }

  componentWillUnmount() {
    this.state.pageHasLoaded = false;
  }

  handleLoad() {

  }

  render() {
    const content = this.props.data.allContentfulHomepage.edges[0].node;
    const customerLogos = this.props.data.customerLogos.nodes;
    const quotesData = this.props.data.allContentfulQuote.edges.map(
        edge => edge.node);
    const metaOptions = [
      {
        property: `og:title`,
        content: content.ogTitle
      },
      {
        property: `og:description`,
        content: content.ogDescription
      },
      {
        property: `og:image`,
        content: content.ogImage.file.url
      }];
    const breadcrumbs = makeBreadCrumbJson([
      {
        name: 'Miuros',
        item: 'https://miuros.com/'
      }
    ]);

    return (
        <BreakpointContext.Consumer>
          {({screenFrom}) => {

            return <>
              <SEO title={content.metaTitle} description={content.metaDescription} meta={metaOptions}
                   breadCrumbJson={breadcrumbs}/>

              <HeroComponent content={content} variant="dark" isHomepage="true"/>

              {
                this.state.pageHasLoaded &&
                <LogoSlider customerLogos={customerLogos}/>
              }

              {/* region VALUE SECTION */}
              <Section margin>
                <Grid>
                  <Row>
                    <Col xs={12} sm={6}>
                      <FluidImageWrapper>
                        <Img fluid={content.valueImage.fluid}/>
                      </FluidImageWrapper>
                    </Col>

                    <Col xs={12} sm={6}>
                      <H3>{content.valueTitle}</H3>
                      <P>{content.valueDescription.valueDescription}</P>
                    </Col>
                  </Row>

                </Grid>
              </Section>
              {/* endregion*/}

              {/* region INSIGHTS, REVIEW, ASSIST*/}

              <FeaturesSection>

                <H2 className="text-center" margin>
                  {content.featuresTitle}
                </H2>

                {/* INSIGHTS */}
                <Container margin>
                  <Grid>

                    <Row reverse={screenFrom('sm')}>
                      <Col xs={12} sm={6}>
                        <FluidImageWrapper>
                          <Img fluid={content.feature2Image.fluid}/>
                        </FluidImageWrapper>
                      </Col>
                      <Col xs={12} sm={6}>
                        <FlexWrapper column align="start">
                          <div>
                            <H6Small color="secondary">
                              {/* TODO extract*/}
                              Insights
                            </H6Small>
                            <H3>
                              {content.feature2Title}
                            </H3>
                            <P>
                              {content.feature2Description.feature2Description}
                            </P>
                          </div>

                          <div className="call-to-action-link-wrapper">
                            <LinkButton href="https://www.dixa.com/miuros-by-dixa"
                                        color="secondary"
                                        label="Learn more about Insights"/>
                          </div>

                        </FlexWrapper>
                      </Col>

                    </Row>

                  </Grid>
                </Container>

                {/* REVIEW */}
                <Container margin>
                  <Grid>

                    <Row>

                      <Col xs={12} sm={6}>
                        <FluidImageWrapper>
                          <Img fluid={content.feature3Image.fluid}/>
                        </FluidImageWrapper>
                      </Col>
                      <Col xs={12} sm={6}>
                        <FlexWrapper column align="start">
                          <H6Small color="tertiary">
                            {/* TODO extract*/}
                            Review
                          </H6Small>
                          <H3>
                            {content.feature3Title}
                          </H3>
                          <P>
                            {content.feature3Description.feature3Description}
                          </P>
                          <div className="call-to-action-link-wrapper">
                            <LinkButton href="https://www.dixa.com/miuros-by-dixa"
                                        color="tertiary"
                                        label="Learn more about Review"/>
                          </div>
                        </FlexWrapper>
                      </Col>

                    </Row>

                  </Grid>
                </Container>

                {/* ASSIST */}
                <Container margin>
                  <Grid>

                    <Row reverse={screenFrom('sm')}>

                      <Col xs={12} sm={6}>
                        <FluidImageWrapper>
                          <Img fluid={content.feature1Image.fluid}/>
                        </FluidImageWrapper>
                      </Col>
                      <Col xs={12} sm={6}>
                        <FlexWrapper column align="start">
                          <div>
                            <H6Small color="primary">
                              {/* TODO extract*/}
                              Assist
                            </H6Small>
                            <H3>
                              {content.feature1Title}
                            </H3>
                            <P>
                              {content.feature1Description.feature1Description}
                            </P>
                          </div>
                          <div className="call-to-action-link-wrapper">
                            <LinkButton href="https://www.dixa.com/miuros-by-dixa"
                                color="primary"
                                label="Learn more about Assist"/>
                          </div>
                        </FlexWrapper>
                      </Col>

                    </Row>

                  </Grid>
                </Container>
              </FeaturesSection>

              {/* endregion */}


              {/* region TESTIMONIALS */}
              {quotesData && quotesData.length > 0 ?
                  <TestimonialSection>
                    <Container>
                      <Grid>
                        {/* TODO extract */}
                        <H2 className="text-center" color="gray100">
                          Our Customers Say It Best
                        </H2>
                      </Grid>
                    </Container>

                    {
                      this.state.pageHasLoaded &&
                      <TestimonialSlider data={quotesData} variant="dark"/>
                    }

                  </TestimonialSection>
                  : null
              }
              {/* endregion */}

              {/* region INTEGRATIONS */}
              <Section margin>
                <Container margin>
                  <Grid>
                    <H2 className="text-center" margin>
                      {content.integrationSectionTitle}
                    </H2>

                    <Row>

                      <Col xs={12} sm={6}>
                        <FluidImageWrapper>
                          <Img fluid={content.integrationImage.fluid}/>
                        </FluidImageWrapper>
                      </Col>

                      <Col xs={12} sm={6}>
                        <FlexWrapper column align="flex-start">
                          <H3>
                            {content.integrationTitle}
                          </H3>
                          <P>
                            {content.integrationDescription.integrationDescription}
                          </P>
                        </FlexWrapper>
                      </Col>
                    </Row>

                  </Grid>
                </Container>

                <Container margin>
                  <Grid>

                    <Row reverse={screenFrom('sm')}>

                      <Col xs={12} sm={6}>
                        <FluidImageWrapper>
                          <Img fluid={content.integrationFastImage.fluid}/>
                        </FluidImageWrapper>
                      </Col>

                      <Col xs={12} sm={6}>
                        <FlexWrapper column align="flex-start">
                          <H3>
                            {content.integrationFastTitle}
                          </H3>
                          <P>
                            {content.integrationFastDescription.integrationFastDescription}
                          </P>
                        </FlexWrapper>
                      </Col>

                    </Row>

                  </Grid>
                </Container>

                <Container margin>
                  <Grid>

                    <Row reverse={screenFrom('sm')}>

                      <Col xs={12} sm={6}>
                        <FluidImageWrapper>
                          <Img fluid={content.integrationSoc2image.fluid}/>
                        </FluidImageWrapper>
                      </Col>

                      <Col xs={12} sm={6}>
                        <FlexWrapper column align="flex-start">
                          <H3>
                            {content.integrationSoc2title}
                          </H3>
                          <P>
                            {content.integrationSoc2description.integrationSoc2description}
                          </P>
                        </FlexWrapper>
                      </Col>

                    </Row>

                  </Grid>
                </Container>

              </Section>
              {/* endregion */}

              <CTABlock
                  title={content.bottomCtaTitle}
              />
            </>;
          }}
        </BreakpointContext.Consumer>
    );
  }
}

export const pageQuery = graphql`
    query HomeQuery
    {
        allContentfulHomepage
        {
            edges
            {
                node
                {
                    id
                    title
                    metaTitle
                    metaDescription
                    ogTitle
                    ogDescription
                    ogImage
                    {
                        file
                        {
                            url
                        }
                    }
                    tagline
                    description
                    valueImage
                    {
                        fluid(maxWidth
                        :
                        470
                        )
                        {
                            ...
                            GatsbyContentfulFluid_withWebp
                        }
                    }
                    valueTitle
                    valueDescription
                    {
                        id
                        valueDescription
                    }
                    promoVideo
                    {
                        file
                        {
                            url
                        }
                    }
                    promoVideoThumbnail
                    {
                        fluid(maxWidth
                        :
                        660
                        )
                        {
                            ...
                            GatsbyContentfulFluid_withWebp
                        }
                    }
                    featuresTitle
                    feature1Title
                    feature1Image
                    {
                        fluid(maxWidth
                        :
                        470
                        )
                        {
                            ...
                            GatsbyContentfulFluid_withWebp
                        }
                    }
                    feature1Description
                    {
                        feature1Description
                    }
                    feature2Title
                    feature2Image
                    {
                        fluid(maxWidth
                        :
                        470
                        )
                        {
                            ...
                            GatsbyContentfulFluid_withWebp
                        }
                    }
                    feature2Description
                    {
                        feature2Description
                    }
                    feature3Title
                    feature3Image
                    {
                        fluid(maxWidth
                        :
                        470
                        )
                        {
                            ...
                            GatsbyContentfulFluid_withWebp
                        }
                    }
                    feature3Description
                    {
                        feature3Description
                    }
                    integrationSectionTitle
                    integrationTitle
                    integrationImage
                    {
                        fluid(maxWidth
                        :
                        470
                        )
                        {
                            ...
                            GatsbyContentfulFluid_withWebp
                        }
                    }
                    integrationDescription
                    {
                        integrationDescription
                    }
                    integrationFastTitle
                    integrationFastImage
                    {
                        fluid(maxWidth:470)
                        {
                            ...
                            GatsbyContentfulFluid_withWebp
                        }
                    }
                    integrationFastDescription
                    {
                        integrationFastDescription
                    }
                    integrationSoc2title
                    integrationSoc2image
                    {
                        fluid(maxWidth:470)
                        {
                            ...
                            GatsbyContentfulFluid_withWebp
                        }
                    }
                    integrationSoc2description
                    {
                        integrationSoc2description
                    }
                    bottomCtaTitle
                    buttonCallForAction
                    buttonRequestDemo
                    buttonLearnAssist
                    buttonLearnInsights
                }
            }
        }
        customerLogos: allContentfulCustomer(
            filter
            :
            {
                showInLogoShowcase: {
                    eq: true
                }
            }
            sort: {
                fields:[customerName], order
                :
                ASC
            }
        )
        {
            nodes
            {
                customerUrl
                balancedLogoColor
                {
                    file
                    {
                        url
                    }
                }
            }
        }
        allContentfulQuote(
            filter
            :
            {
                relatedTo: {
                    eq: "home"
                }
            }
        )
        {
            edges
            {
                node
                {
                    content
                    authorFirstName
                    authorLastName
                    authorJobTitle
                    authorCompany
                    {
                        customerName
                        customerUrl
                        balancedLogoColor
                        {
                            file
                            {
                                url
                            }
                        }
                    }
                }
            }
        }

        site
        {
            siteMetadata
            {
                title
            }
        }
    }
`;
